import { Component, Input, OnInit } from '@angular/core';
import { ExerciseContainer } from '../../agenda/agenda.component';

@Component({
  selector: 'app-agenda-block-conference',
  templateUrl: './agenda-block-conference.component.html',
  styleUrls: ['./agenda-block-conference.component.scss']
})
export class AgendaBlockConferenceComponent implements OnInit {

  @Input() container: ExerciseContainer = null;

  constructor() { }

  ngOnInit(): void {
  }

}
